const SWEDISH_DATE_FORMAT_PLACEHOLDER_PATTERN = /ÅÅÅÅ-MM-DD/g

export {
  SWEDISH_DATE_FORMAT_PLACEHOLDER_PATTERN,
}
